import { Typography } from "antd";

import { GenericImagesTable } from "../../../components/tables/ImagesTable";

function Images() {
  return (
    <div>
      <Typography.Title level={2}>Images</Typography.Title>
      <GenericImagesTable></GenericImagesTable>
    </div>
  );
}

export default Images;

